import React, { Component } from 'react';
import Popup from 'react-popup';

/**
 * ENV VAR That containt the content of methodology popup
 */
const {
  REACT_APP_METHODOLOGY_DESCRIPTION,
} = process.env;

class Methodology extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popup: '',
    };
    // Title of popup
    this.title = 'Methodology';
    this.openPopup = this.openPopup.bind(this);
  }

  /**
   * This method allow to set the title, content and className
   */
  componentDidMount() {
    this.setState({
      popup: Popup.register({
        title: `${this.title}`,
        content: this.popupContent(),
        className: 'mm-popup',
      }),
    });
  }

  /**
   * Return the Content of the popup
   */
  popupContent = () => (
    <div>
      <p>
        {' '}
        {REACT_APP_METHODOLOGY_DESCRIPTION}
        {' '}
      </p>
    </div>
  )

  /**
   * Method to open the popup
   */
  openPopup() {
    const { popup } = this.state;
    Popup.queue(popup);
  }

  render() {
    return (
      <div className="methodology">
        <div className="methodology__button">
          <button className="button-top" type="button" onClick={this.openPopup}> See the methodology </button>
        </div>
        <Popup />
      </div>
    );
  }
}

export default Methodology;
